import videojs from 'video.js';

const Plugin = videojs.getPlugin('plugin');

class PianoAvInsights extends Plugin {

    isVideoEnded = true;

    constructor(player) {

        super(player);

        this.player.ready(() => {
            this.player.Simplestream().tag('Piano Analytics');
            this.player.Simplestream().debug('PianoAvInsights Plugin Loaded');
            //if(typeof pa === "undefined") {
            //  alert('Piano Analytics are enabled but "pa" is undefined.');
            //} else {
              this.init();
            //}
        });

    }

    init = () => {

        var analyticsApiResponse = this.player.Simplestream().analyticsApiResponse;

        this.paCustomParams = {};
        this.paCustomParams.av_content_id = analyticsApiResponse['content.id'];
        this.paCustomParams.av_content = analyticsApiResponse['content.title'];
        this.paCustomParams.av_content_duration = this.player.duration() * 1000;

        this.videoMedia = new pa.avInsights.Media({0:5,1:10,5:60});

        console.log('pa.avInsights.Media({0:5,1:10,5:60})');

        this.videoMedia.setProps(this.paCustomParams);

        console.log('pa.avInsights.setProps()', this.paCustomParams);

        // to check pause state
        this.playbackPaused = true;
        // to control first play event
        this.firstPlayEvent = true;
        // to control first playbackStart event
        this.firstPlaybackStartEvent = true;
        // to save old Cursor Position at seek start
        this.oldCursorPosition = 0;
        // to check video end event when video change 
        this.isVideoEnded = false;
        // to check previous fullscreen on
        this.fullscreenOn = false;
        // to check volume change
        this.playerVolume = 0;
        // to check playback speed change
        this.playerPlaybackSpeed = 0;
        // to check video quality change
        this.videoQuality = "";
        // to set the value of ad end
        this.adEndTime = 0;
        // to track video time
        this.videoTime = 0;

        /**
         * Events related to player
         */
        /*this.player.on(dailymotion.events.PLAYER_VIDEOCHANGE, (state) => {
            // if video_end in case of user interaction
            if (!this.isVideoEnded) {
                this.videoMedia.playbackStopped(this.videoTime * 1000);
            }
            this.avataginit(state);
        });*/

        /**
         * Events related to content video
         */
        this.player.on('play', (state) => {
            // if player is starting
            if (this.firstPlayEvent) {
                this.firstPlayEvent = false;
                this.videoMedia.play(state.videoTime * 1000);
            }
        });

        this.player.on(dailymotion.events.VIDEO_BUFFERING, (state) => {
            // if ad end time and this event has same videoTime then ignore
            if (this.adEndTime && this.adEndTime === parseInt(state.videoTime)) return;
            /**
             * always send playbackPaused event before buffering start
             * before "playbackStart" no need to send playbackPaused event
             * if player is already paused state, no need to send pause event
             */
            if (!this.firstPlaybackStartEvent && !this.playbackPaused) {
                this.playbackPaused = true;
                this.videoMedia.playbackPaused(state.videoTime * 1000);
            }
            this.oldCursorPosition = state.videoTime * 1000;
            this.videoMedia.bufferStart(state.videoTime * 1000);
        });

        this.player.on('playing', (state) => {
            // if already playing ignore it
            if (!this.playbackPaused) return;
                this.playbackPaused = false;
            if (this.firstPlaybackStartEvent) {
                // set player volume at start time
                this.playerVolume = state.playerIsMuted ? 0 : state.playerVolume.toFixed(1);
                // set playback speed at start time
                this.playerPlaybackSpeed = state.playerPlaybackSpeed;
                // set video quality at start time
                this.videoQuality = state.videoQuality;
                this.videoMedia.playbackStart(state.videoTime * 1000);
                this.firstPlaybackStartEvent = false;
            } else {
                this.videoMedia.playbackResumed(state.videoTime * 1000);
            }
        });

        this.player.on('pause', (state) => {
            this.playbackPaused = true;
            this.videoMedia.playbackPaused(state.videoTime * 1000);
        });

        this.player.on('end', (state) => {
            this.isVideoEnded = true;
            this.videoMedia.playbackStopped(state.videoTime * 1000);
        });

        this.player.on('seeking', (state) => {
            // if ad end time and this event has same videoTime then ignore
            if (this.adEndTime && this.adEndTime === parseInt(state.videoTime)) return;
            // if player already paused dont send pause event
            if (!this.playbackPaused) {
                this.playbackPaused = true;
                this.videoMedia.playbackPaused(state.videoTime * 1000);
            }
            this.oldCursorPosition = state.videoTime * 1000;
        });

        this.player.on('seeked', (state) => {
            // if ad end time and this event has same videoTime then ignore
            if (this.adEndTime && this.adEndTime === parseInt(state.videoTime)) return;
            // do not send this evens before playback start event
            if (!this.firstPlaybackStartEvent) {
                this.videoMedia.seek(this.oldCursorPosition, state.videoTime * 1000);
            }
        });

        // To track video time
        this.player.on('timeupdate', (state) => {
            this.videoTime = state.videoTime;
        });

        /**
         * Contextual events : The following list of events is not taken 
         * into account in the calculation of media consumption times.
         * They are one-time contextual events
         */
        this.player.on(dailymotion.events.AD_CLICK, (state) => {
            this.videoMedia.adClick();
        });

        this.player.on(dailymotion.events.AD_END, (state) => {
            this.adEndTime = parseInt(state.videoTime);
            if (state.adEndedReason === "skipped") {
            this.videoMedia.adSkip();
            }
        });

        this.player.on(dailymotion.events.PLAYER_ERROR, (state) => {
            this.videoMedia.error(state.playerError && state.playerError.title);
        });

        this.player.on(dailymotion.events.PLAYER_PRESENTATIONMODECHANGE, (state) => {
            if (state.playerPresentationMode === "fullscreen") {
            this.fullscreenOn = true;
            this.videoMedia.fullscreenOn();
            } else if (this.fullscreenOn) {
            this.fullscreenOn = false;
            this.videoMedia.fullscreenOff();
            }
        });

        this.player.on(dailymotion.events.VIDEO_QUALITYCHANGE, (state) => {
            // do not send this evens before playback start event
            // do not send this event if videoQuality did not change
            if (!this.firstPlaybackStartEvent && (this.videoQuality !== state.videoQuality)) {
            this.videoQuality = state.videoQuality;
            console.log(state.videoQuality);
            this.videoMedia.quality();
            }
        });

        this.player.on(dailymotion.events.VIDEO_SUBTITLESCHANGE, (state) => {
            if (state.videoSubtitles) {
            this.videoMedia.subtitleOff();
            } else {
            this.videoMedia.subtitleOn();
            }
        });

        /*this.player.on(dailymotion.events.PLAYER_VOLUMECHANGE, (state) => {
            let volume = state.playerIsMuted ? 0 : state.playerVolume.toFixed(1);
            // do not send this evens before playback start event
            // do not send this event if volume did not change
            if (!this.firstPlaybackStartEvent && (this.playerVolume !== volume)) {
            this.playerVolume = volume;
            this.videoMedia.volume();
            }
        });*/

        /**
         * adding puase event when ad start
         */
        this.player.on(dailymotion.events.AD_START, (state) => {
            if (!this.playbackPaused) {
            this.playbackPaused = true;
            this.videoMedia.playbackPaused(state.videoTime * 1000);
            };
        });
        
    }
      
}

PianoAvInsights.defaultState = {};
videojs.registerPlugin('PianoAvInsights', PianoAvInsights);
export default PianoAvInsights;